import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import initDB from "./db";
var Logger = /*#__PURE__*/function () {
  function Logger(name) {
    _classCallCheck(this, Logger);
    _defineProperty(this, "isLog", void 0);
    _defineProperty(this, "name", void 0);
    _defineProperty(this, "db", void 0);
    this.name = name || '';
  }
  _createClass(Logger, [{
    key: "initdb",
    value: function initdb() {
      try {
        var _window$__ZZ_LEGO_CON;
        if (typeof window === 'undefined') {
          return;
        }
        if (window.indexedDB && (_window$__ZZ_LEGO_CON = window.__ZZ_LEGO_CONFIG) !== null && _window$__ZZ_LEGO_CON !== void 0 && _window$__ZZ_LEGO_CON.debugger) {
          var _window$__ZZ_LEGO_CON2;
          this.db = initDB();
          if (!((_window$__ZZ_LEGO_CON2 = window.__ZZ_LEGO_CONFIG) !== null && _window$__ZZ_LEGO_CON2 !== void 0 && _window$__ZZ_LEGO_CON2.debuggerCache)) {
            this.db.clearStore('logs');
            this.db.clearStore('events');
          }
        }
      } catch (error) {}
    }
  }, {
    key: "info",
    value: function () {
      var _info = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(message, content) {
        var _window$__ZZ_LEGO_CON3;
        var msg, _window$__ZZ_LEGO_CON4;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(typeof window === 'undefined')) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              if (!this.db) this.initdb();
              msg = "[".concat(this.name, "]") + ' ' + message;
              if ((_window$__ZZ_LEGO_CON3 = window.__ZZ_LEGO_CONFIG) !== null && _window$__ZZ_LEGO_CON3 !== void 0 && _window$__ZZ_LEGO_CON3.log) {
                console.log(msg, content ? content : '');
              }
              _context.prev = 5;
              if (!(this.db && (_window$__ZZ_LEGO_CON4 = window.__ZZ_LEGO_CONFIG) !== null && _window$__ZZ_LEGO_CON4 !== void 0 && _window$__ZZ_LEGO_CON4.debugger)) {
                _context.next = 9;
                break;
              }
              _context.next = 9;
              return this.db.putData('logs', {
                type: 'info',
                time: new Date().getTime(),
                data: {
                  msg: msg,
                  content: content
                }
              });
            case 9:
              _context.next = 13;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](5);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[5, 11]]);
      }));
      function info(_x, _x2) {
        return _info.apply(this, arguments);
      }
      return info;
    }()
  }, {
    key: "warn",
    value: function () {
      var _warn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(message) {
        var _window$__ZZ_LEGO_CON5;
        var msg, _window$__ZZ_LEGO_CON6;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(typeof window === 'undefined')) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              msg = "[".concat(this.name, "]") + ' ' + message;
              if ((_window$__ZZ_LEGO_CON5 = window.__ZZ_LEGO_CONFIG) !== null && _window$__ZZ_LEGO_CON5 !== void 0 && _window$__ZZ_LEGO_CON5.log) {
                console.warn(msg);
              }
              _context2.prev = 4;
              if (!(this.db && (_window$__ZZ_LEGO_CON6 = window.__ZZ_LEGO_CONFIG) !== null && _window$__ZZ_LEGO_CON6 !== void 0 && _window$__ZZ_LEGO_CON6.debugger)) {
                _context2.next = 8;
                break;
              }
              _context2.next = 8;
              return this.db.putData('logs', {
                type: 'warn',
                time: new Date().getTime(),
                data: {
                  msg: msg,
                  content: ''
                }
              });
            case 8:
              _context2.next = 12;
              break;
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](4);
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[4, 10]]);
      }));
      function warn(_x3) {
        return _warn.apply(this, arguments);
      }
      return warn;
    }()
  }, {
    key: "error",
    value: function () {
      var _error = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(message) {
        var msg, _window$__ZZ_LEGO_CON7;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(typeof window === 'undefined')) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              msg = "[".concat(this.name, "]") + ' ' + message;
              console.error(msg);
              _context3.prev = 4;
              if (!(this.db && (_window$__ZZ_LEGO_CON7 = window.__ZZ_LEGO_CONFIG) !== null && _window$__ZZ_LEGO_CON7 !== void 0 && _window$__ZZ_LEGO_CON7.debugger)) {
                _context3.next = 8;
                break;
              }
              _context3.next = 8;
              return this.db.putData('logs', {
                type: 'error',
                time: new Date().getTime(),
                data: {
                  msg: msg,
                  content: ''
                }
              });
            case 8:
              _context3.next = 12;
              break;
            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](4);
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[4, 10]]);
      }));
      function error(_x4) {
        return _error.apply(this, arguments);
      }
      return error;
    }()
  }]);
  return Logger;
}();
export default new Logger('lego日志');